import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface ConfirmActionDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmColor?: 'primary' | 'error';
  busy?: boolean;
  children?: React.ReactNode;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
}

export const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmColor = 'primary',
  busy = false,
  children,
  onClose,
  onConfirm,
}) => {
  return (
  <Dialog
    open={open}
    onClose={busy ? undefined : onClose}
    fullWidth
    maxWidth="xs"
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Typography variant="body2">{message}</Typography>
      {children}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={busy}>{cancelLabel}</Button>
      <Button
        variant="contained"
        color={confirmColor}
        onClick={onConfirm}
        disabled={busy}
        startIcon={busy ? <CircularProgress size={18} color="inherit" /> : undefined}
      >
        {busy ? 'Working...' : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
  );
};
